import styled from 'styled-components'
import { breakpoints } from '@/styles'

export const HeartImage = styled.img`
  height: 24px;
  margin: 0 5px;
  cursor: pointer;

  :hover,
  :active {
    opacity: 0.7;
  }

  @media screen and (max-width: ${breakpoints.tabletLandscape}) {
    margin: 8px 0;

    :hover {
      opacity: 1;
    }
  }
`
